import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import defaultStyles from './styles.scss'

const SectionHeader = (props) => {
  const { maximized, styles, title } = props

  return (
    <div
      className={classnames(defaultStyles.root, maximized ? defaultStyles.maximized : null, styles.sectionHeaderRoot)}
    >
      <span className={defaultStyles.title}>{title}</span>
      <hr className={classnames(defaultStyles.divider, styles.sectionHeaderDivider)} />
    </div>
  )
}

SectionHeader.propTypes = {
  styles: PropTypes.object,
  title: PropTypes.string,
  maximized: PropTypes.bool,
}

SectionHeader.defaultProps = {
  styles: {},
}

export default SectionHeader
